import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitM2} from 'shared/dtos/cockpit/cockpit';
import {KennzahlenDerMethodik} from 'shared/dtos/cockpit/kennzahlen-der-methodik';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {
  CockpitChartComponent,
  CockpitChartParentComponent,
  CockpitChartParentComponentWithCurrentLocale,
  CockpitContentComponent
} from '../../cockpit-shared/cockpit-content-component';
import {ChartDialogRisikopaareComponent} from './chart-dialog-kennzahlen-methodik/chart-dialog-risikopaare.component';

@Component({
  selector: 'app-kennzahlen-methodik-m2',
  templateUrl: './kennzahlen-methodik-m2.component.html',
  styleUrls: [
    './kennzahlen-methodik-m2.component.scss',
    '../../cockpit-shared/card/card.component.scss'
  ],
  standalone: false
})
export class ChartDialogKennzahlenMethodikM2Component
  extends CockpitChartParentComponentWithCurrentLocale
  implements OnInit, AfterViewInit, CockpitContentComponent
{
  @ViewChild(ChartDialogRisikopaareComponent)
  chartChild!: CockpitChartComponent;

  tableHeaders = [
    'm2.sprint2.cockpit.card.kennzahlenMethodik.gewichtungsfaktoren',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.korrelationskoeffizienten',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.anzahlRisikopaare',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.statischeWerte',
    'm2.sprint2.cockpit.card.kennzahlenMethodik.regressionsergebnisse'
  ];

  kennzahlen: KennzahlenDerMethodik;
  card: CockpitCard;
  chartChildren: CockpitChartComponent[];
  crtLocale: string;
  prioritaetAlter: boolean;

  constructor(
    private readonly storage: DataStorageService,
    private readonly exportTable: TableExportService,
    protected readonly translate: TranslateService
  ) {
    super(translate);
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const cockpit = (await this.storage.getCockpitData()) as CockpitM2;
    this.kennzahlen = cockpit.kennzahlenDerMethodik;
    this.prioritaetAlter = await this.storage.getPrioritaetAlter();
  }

  ngAfterViewInit(): void {
    this.chartChildren = [this.chartChild];
  }

  downloadTable(id: string, tableHeaderIndex: number) {
    this.exportTable.exportHtmlTable(id, this.tableHeaders[tableHeaderIndex]);
  }
}
